import { HttpParams } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import Swal from "sweetalert2";
import { WalletService } from "../wallet.service";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

@Component({
  selector: "app-manage-admin-funds",
  templateUrl: "./manage-admin-funds.component.html",
  styleUrls: ["./manage-admin-funds.component.scss"],
})
export class ManageAdminFundsComponent
  extends FeaturesBaseComponent
  implements OnInit, OnDestroy
{
  numberMask = createNumberMask({
    prefix: "$ ",
    suffix: "",
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ",",
    allowDecimal: true,
  });
  manageAdminFundsForm: FormGroup;
  filteredOptions: any;
  retailerChecked: boolean = false;
  retailerDetailsList: any;
  retailerAccountSummary: any;
  retailerList: any[] = [];
  retailerDetails: any;
  selectedRetailerAccId: any;
  isAddFunds: boolean = true;
  isRemoveFunds: boolean = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private walletService: WalletService,
    private toastService: ToastrService
  ) {
    super();

    this.initForm();
  }

  onAddFunds() {
    this.isRemoveFunds = false;
    this.isAddFunds = true;
    this.manageAdminFundsForm.reset();
    // this.reloadComponent();

    this.manageAdminFundsForm.get("amount").setValue("");
  }
  onRemoveFunds() {
    this.isRemoveFunds = true;
    this.isAddFunds = false;
    this.manageAdminFundsForm.reset();
    // this.reloadComponent();
    this.manageAdminFundsForm.get("amount").setValue("");
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getAllRetailersList();
    this.manageAdminFundsForm.controls["accountNumber"].valueChanges.subscribe(
      (res) => {
        if (res && res) {
         
          let retailerAccountNum: string;
          if (res?.retailerAccountNum) {
            retailerAccountNum = res.retailerAccountNum;
          } else {
            retailerAccountNum = res;
          }
          this.filteredOptions = this.retailerList;

          this.filteredOptions = res
            ? this._filterAccountNumber(retailerAccountNum)
            : this.retailerList.slice();
        }
      }
    );

    this.manageAdminFundsForm.controls["retailerName"].valueChanges.subscribe(
      (res) => {
        if (res && res) {
          let retailerName: string;
          if (res?.retailerName) {
            retailerName = res.retailerName;
          } else {
            retailerName = res;
          }

          this.filteredOptions = this.retailerList;

          this.filteredOptions = res
            ? this._filterRetailerName(retailerName)
            : this.retailerList.slice();
        }
      }
    );
  }

  keyUpEvent(event) {
    let totalAmount: any;
    let amount = event.target.value;
    amount = amount.replace("$", "").replace(",", "").replace(" ", "");
    let currAmount = this.manageAdminFundsForm.get("currentAmount").value;
    if (this.isAddFunds && currAmount >= 0) {
      totalAmount =
        Number(amount) + Number(this.retailerAccountSummary.currentAmount);
    } else if (this.isRemoveFunds && currAmount > 0) {
      totalAmount =
        Number(this.retailerAccountSummary.currentAmount) - Number(amount);
    }
    this.manageAdminFundsForm.patchValue({
      newBalance: parseFloat(totalAmount).toFixed(2),
      // currentAmount: this.retailerAccountSummary.currentAmount,
    });
    // 
  }

  getOptionText(option) {
    if (option != null && option != undefined) {
      return option.retailerAccountNum;
    }
    return;
  }

  selectedAccountNumber(data) {
   
    this.walletService
      .getallRetailerDetailsById(
        data.option.value["retailerDetails"].retailerId
      )
      .subscribe((res) => {
        let resData: any = res;
        if (resData.responseCodes.find((x) => x == "TILA_101")) {
          this.retailerDetailsList = resData.data;
         
          this.retailerDetails = resData.data.retailerDetails;
          // seperate and rename key from businessName to retailerName to match autocomplete
          let _retailerDetails: any = [];
          this.retailerDetailsList.retailerDetails.businessName;
          _retailerDetails["retailerName"] =
            this.retailerDetailsList.retailerDetails.businessName;
          this.retailerAccountSummary = resData.data.retailerAccountSummary;
          this.manageAdminFundsForm.patchValue({
            retailerName: _retailerDetails,
            retailerType: this.retailerDetails.retailerType,
            mobileNumber: this.retailerDetails.otpMobileNumber,
            businessName: this.retailerDetails.businessName,
            dbaName: this.retailerDetails.dbaName,
            address1: this.retailerDetails.address1,
            currentAmount: parseFloat(
              this.retailerAccountSummary.currentAmount
            ).toFixed(2),
          });
        }
      });
  }

  getAllRetailersList() {
    this.walletService.getSlaesReproleRetailerList().subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
       
        this.retailerList = resData.data;
        this.filteredOptions = this.retailerList;
      }
    });
  }

  getOptionretailerName(option) {
    if (option != null && option != undefined) {
      return option.retailerName;
    }
  }

  selectedRetailerName(data) {
    this.retailerAccountSummary = data.option.value;
   
    this.walletService
      .getallRetailerDetailsById(
        data.option.value["retailerDetails"].retailerId
      )
      .subscribe((res) => {
        if (res["httpcode"] == 200) {
          this.retailerDetailsList = res.data;
          this.selectedRetailerAccId =
            this.retailerAccountSummary.retailerAccountId;
          this.manageAdminFundsForm.patchValue({
            accountNumber: this.retailerAccountSummary,
            retailerType:
              this.retailerAccountSummary.retailerDetails.retailerType,
            mobileNumber:
              this.retailerAccountSummary.retailerDetails.otpMobileNumber,
            businessName:
              this.retailerAccountSummary.retailerDetails.businessName,
            dbaName: this.retailerAccountSummary.retailerDetails.dbaName,
            address1: this.retailerAccountSummary.retailerDetails.address1,
            currentAmount: parseFloat(
              this.retailerAccountSummary.currentAmount
            ).toFixed(2),
          });
        }
      });
  }

  initForm = () => {
    this.manageAdminFundsForm = this.fb.group(
      {
        accountNumber: [""],
        retailerName: "",
        retailerType: "",
        mobileNumber: "",
        businessName: "",
        dbaName: "",
        address1: "",
        currentAmount: "",
        amount: "",
        newBalance: "",
      },
      {
        validator: this.priceValidation("currentAmount", "amount"),
      }
    );
  };

  get f() {
    return this.manageAdminFundsForm.controls;
  }

  onAddFundSubmit = () => {
    //;
    if (this.manageAdminFundsForm.invalid) {
      return;
    } else {
     
      let httpParams = new HttpParams()
        .set(
          "amount",
          this.manageAdminFundsForm
            .get("amount")
            .value.replace("$", "")
            .replace(",", "")
            .replace(" ", "")
        )
        .set(
          "retailer_account_id",
          this.retailerDetailsList.retailerAccounts.retailerAccountId
        )
        .set(
          "salesrep_account_id",
          this.retailerDetailsList.retailerSalesRepAssignment.userId
        );
      if (this.isAddFunds) {
        this.walletService.addReatilerAmount(httpParams).subscribe((res) => {
          if (
            (res["httpcode"] == 200 &&
              res.responseCodes.find((x) => x == "TILA_101")) ||
            res.responseStatus == "Success"
          ) {
            this.manageAdminFundsForm.reset();
            this.toastService.success("Funds added successfully!", "Success", {
              timeOut: 2500,
              progressBar: true,
              progressAnimation: "decreasing",
            });
            //this.router.navigate(['features/wallet'])
            this.reloadComponent();
          }
        });
        return;
      }
      if (this.isRemoveFunds) {
        this.walletService.removeReatilerAmount(httpParams).subscribe((res) => {
          if (
            (res["httpcode"] == 200 &&
              res.responseCodes.find((x) => x == "TILA_101")) ||
            res.responseStatus == "Success"
          ) {
            this.manageAdminFundsForm.reset();
            this.toastService.success(
              "Funds removed successfully!",
              "Success",
              {
                timeOut: 2500,
                progressBar: true,
                progressAnimation: "decreasing",
              }
            );
            //this.router.navigate(['features/wallet'])
            this.reloadComponent();
          }
        });
      }
    }
  };

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onCancel() {
    this.manageAdminFundsForm.reset();
    this.reloadComponent();
    this.router.navigate(["features/wallet"]);
  }

  private _filterAccountNumber(value: string) {
    const filterValue = value.toLowerCase();
    return this.retailerList.filter(
      (obj) => obj.retailerAccountNum.toLowerCase().indexOf(filterValue) === 0
    );
  }

  private _filterRetailerName(value: string) {
   
    const filterValue = value.replace(/\s/g, "").toLowerCase();
    return this.filteredOptions.filter(
      (obj) =>
        obj.retailerName
          .replace(/\s/g, "")
          .toLowerCase()
          .indexOf(filterValue) === 0
    );
  }
  priceValidation(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }
      let totalAmount: number;
      if (this.isAddFunds) {
        totalAmount = Number(control.value) + Number(matchingControl.value);
      }
      if (this.isRemoveFunds) {
        totalAmount = Number(control.value) - Number(matchingControl.value);
      }
      // set error on matchingControl if validation fails
      if (totalAmount < 0) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate([currentUrl]);
  }
}
